import { IconTab } from "@/src/components/iconTab";
import {
  AnesthesiologySummary,
  Hospitalisation,
  Patient,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId, jsonAbstract } from "@/src/utils/utils";
import { FaStethoscope } from "react-icons/fa";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";
import { CONFIG } from "@/src/data/globalVariables";
import { RiLungsLine, RiMedicineBottleLine } from "react-icons/ri";
import { MdOutlineMedicalServices } from "react-icons/md";

function AnesthesiologySummaryButton({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: AnesthesiologySummary) => void;
}) {
  return (
    <IconTab
      id={"anesthesiologySummary"}
      activeTabId={null}
      isHorizontal={true}
      name={"Résumé d'anesthésie"}
      icon={<MdOutlineMedicalServices size={20} />}
      onChange={async () => {
        await openNewAnesthesiologySummaryForm({
          patient,
          parent,
          onSave,
        });
      }}
    />
  );
}

export async function openNewAnesthesiologySummaryForm({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: AnesthesiologySummary) => void;
}) {
  let referenceId = jsonAbstract(
    getItemId(CONFIG.get()?.anesthesiologySummaryForm)
  ) as string;
  if (!referenceId)
    throw new Error(
      "Aucun formulaire d'anesthésie trouvé, veuillez contacter l'administrateur"
    );
  let reference = await apiFetch(
    "references",
    "loadOne",
    { referenceId },
    "Erreur lors du chargement de la référence"
  );

  let item: AnesthesiologySummary = {
    type: "anesthesiologySummary",
    patient,
    creator: getUserId(),
    parent,
    reference,
    refAnswer: {
      patient,
      creator: getUserId(),
      fieldAnswers: [],
      reference,
    },
    confidentiality: getStandardConfidentiality(patient),
    readBy: [getUserId()],
  };

  return await openEvolutionItemStandardForm({
    item,
    patient,
    onConfirm: async (newItem) => {
      newItem = await apiFetch("anesthesiologySummaries", "addOne", {
        anesthesiologySummary: newItem,
      });
      onSave(newItem);
    },
  });
}

export default AnesthesiologySummaryButton;
